'use client'

import superjson from 'superjson'
import type { QueryClient } from '@tanstack/react-query'
import { QueryClientProvider } from '@tanstack/react-query'
import { httpBatchLink } from '@trpc/client'
import { trpc } from '@/trpc/client'
import { makeQueryClient } from './queryClient'

let clientQueryClientSingleton: QueryClient | null = null
function getQueryClient() {
  if (typeof window === 'undefined') {
    return makeQueryClient()
  }
  return (clientQueryClientSingleton ??= makeQueryClient())
}

let clientTrpcClientSingleton: ReturnType<typeof trpc.createClient> | null =
  null
function getTrpcClient() {
  if (typeof window === 'undefined') {
    return trpc.createClient({
      links: [httpBatchLink({ transformer: superjson, url: '/api' })],
    })
  }
  return (clientTrpcClientSingleton ??= trpc.createClient({
    links: [httpBatchLink({ transformer: superjson, url: '/api' })],
  }))
}

export function TRPCProvider(
  props: Readonly<{
    children: React.ReactNode
  }>
) {
  const queryClient = getQueryClient()
  const trpcClient = getTrpcClient()
  const Provider = trpc.Provider

  return (
    <Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        {props.children}
      </QueryClientProvider>
    </Provider>
  )
}
